import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/v2/payment/banks'

export default {
  namespaced: true,
  state: {
    ...baseState,
    options: {
      branches: [],
      currencies: [],
      payment_profiles: [],
      khqr_providers: []
    }
  },
  mutations: {
    ...baseMutations,
    RECEIVE_OPTIONS(state, response) {
      const options = response.data.data || {}
      state.options = {
        branches: (options.branches || []).map(branch => ({
          ...branch,
          branch_id: Number(branch.branch_id)
        })),
        currencies: (options.currencies || []).map(currency => ({
          ...currency,
          currency_id: Number(currency.currency_id)
        })),
        payment_profiles: (options.payment_profiles || []).map(profile => ({
          ...profile,
          id: Number(profile.id)
        })),
        khqr_providers: options.khqr_providers || []
      }
    }
  },
  actions: {
    async fetch(context, attributes = {}) {
      let params = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
          search: context.state.search
        },
        attributes
      )
      let response = await httpClient.get(BASE_URL, { params })
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    async fetchOptions(context) {
      let response = await httpClient.get(`${BASE_URL}/options`)
      context.commit('RECEIVE_OPTIONS', response)
      return response
    },
    find(context, id) {
      return httpClient.get(`${BASE_URL}/${id}`)
    },
    onSave(context, data) {
      return httpClient.post(BASE_URL, data)
    },
    onUpdate(context, data) {
      return httpClient.put(`${BASE_URL}/${data.bank_id}`, data)
    },
    uploadLogo(context, data) {
      return httpClient.post(`${BASE_URL}/upload-logo`, data)
    },
    onDelete(context, id) {
      return httpClient.delete(`${BASE_URL}/${id}`)
    }
  }
}
